import React, { useMemo } from "react";
import { getColors } from "../../../utils";
import { Container, ContainerFW } from "../../../header";
import { FeaturesList } from "./FeaturesList/FeaturesList";
import { TrustPilotMiniBanner } from "./TrustPilotMiniBanner/TrustPilotMiniBanner";
import { CheckOutButton } from "./CheckOutButton/CheckOutButton";
import { TradingViewSection } from "../../M38StatsAndTrustPilot/TradingViewSection/TradingViewSection";
export const StatsLineRibbonBanner = ({ features, backgroundColor, trustPilotLocale, checkOutButtonValues, trustPilotTheme = "light", showTradingViewSection, ratingLabel, tradingViewLogoUrl, ratingScore }) => {
    const { bgColor, textColor } = getColors(backgroundColor);
    const handleSeparatorElement = useMemo(() => {
        if (showTradingViewSection) {
            return (React.createElement("div", { className: "stats-line-ribbon-banner__pipeSeparator" }));
        }
        return React.createElement(React.Fragment, null);
    }, [showTradingViewSection]);
    return (React.createElement(ContainerFW, { backgroundColor: bgColor, className: "g-container--new" },
        React.createElement(Container, { className: "g-container--new" },
            React.createElement("div", { className: "stats-line-ribbon-banner__root" },
                React.createElement("div", { className: "stats-line-ribbon-banner__root__features" }, features.length > 0 && features.map((a) => (React.createElement(FeaturesList, { key: `unique${a.featureTitle}`, ...a })))),
                React.createElement("div", { className: `${showTradingViewSection ? "with-trading-view" : ""}` },
                    showTradingViewSection && React.createElement(TradingViewSection, { evaluation: ratingLabel, logoUrl: tradingViewLogoUrl, marks: ratingScore, textColor: textColor }),
                    handleSeparatorElement,
                    React.createElement(TrustPilotMiniBanner, { theme: trustPilotTheme, locale: trustPilotLocale })),
                checkOutButtonValues.title && React.createElement(CheckOutButton, { ...checkOutButtonValues })))));
};
